var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.675a9 9 0 11-18 0 9 9 0 0118 0z",
    fill: "#F8E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.89 8.2a1 1 0 00-1.415-1.414L13.889 8.2zm-7.78 4.95a1 1 0 101.415 1.414L6.111 13.15zm6.365 1.414a1 1 0 001.414-1.414l-1.414 1.414zm-4.95-7.778A1 1 0 106.111 8.2l1.414-1.414zM18 10.675a8 8 0 01-8 8v2c5.523 0 10-4.477 10-10h-2zm-8 8a8 8 0 01-8-8H0c0 5.523 4.477 10 10 10v-2zm-8-8a8 8 0 018-8v-2c-5.523 0-10 4.477-10 10h2zm8-8a8 8 0 018 8h2c0-5.523-4.477-10-10-10v2zm2.475 4.11L9.293 9.969l1.414 1.414L13.89 8.2l-1.414-1.414zM9.293 9.969L6.11 13.15l1.414 1.414 3.182-3.182-1.414-1.414zm4.596 3.182l-3.182-3.182-1.414 1.414 3.182 3.182 1.414-1.414zm-3.182-3.182L7.525 6.786 6.111 8.2l3.182 3.182 1.414-1.414z",
    fill: "#DE726E"
  })));
}
export default SvgCons;